<div class="sz-tile" [class.sz-tile--lime]="variant() === 'lime'">
  <div class="sz-tile__label">{{ label() }}</div>
  <div class="sz-tile__value-row">
    <span class="sz-tile__value">{{ value() }}</span>
    @if (unit(); as unitText) {
      <span class="sz-tile__unit">{{ unitText }}</span>
    }
  </div>
  @if (trend(); as trendText) {
    <span
      class="sz-tile__trend"
      [class.sz-tile__trend--up]="trendDirection() === 'up'"
      [class.sz-tile__trend--down]="trendDirection() === 'down'"
      [class.sz-tile__trend--neutral]="trendDirection() === 'neutral'"
      >{{ trendText }}</span
    >
  }
  @if (trendBaseline(); as baseline) {
    <span class="sz-tile__trend-base">{{ baseline }}</span>
  }
</div>
